/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose a preset" |
*
* @param {Subtitle_Export_Preset_Load_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_placeholder = /** @type {((inputs?: Subtitle_Export_Preset_Load_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un préréglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Voreinstellung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli un preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предустановку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija un ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक प्रीसेट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha uma predefinição")
	return /** @type {LocalizedString} */ ("Choose a preset")
});